export const WHATSAPP_URL = 'https://api.whatsapp.com/send/?phone=97450000742&text&app_absent=0'
